import { addDays, parseISO } from "date-fns";
import { useState } from "react";

import { taskCalendarDate, type Task, type TaskReminder } from "@recobra/schemas/task";

import { useRemoveTaskReminder, useSaveTaskReminder } from "./useTaskReminderMutations";

export const useTaskReminderDraft = ({
  task,
  reminder,
  isNew,
  onDiscardNew,
}: {
  task: Task;
  reminder: TaskReminder;
  isNew: boolean;
  onDiscardNew: () => void;
}) => {
  const storedComment = reminder.comment ?? "";
  const [scheduledDate, setScheduledDate] = useState(reminder.scheduledDate);
  const [comment, setComment] = useState(storedComment);
  const today = taskCalendarDate(new Date());
  const removeMutation = useRemoveTaskReminder(task, reminder.id);
  const saveMutation = useSaveTaskReminder({
    task,
    reminder,
    isNew,
    scheduledDate,
    comment,
    onStored: onDiscardNew,
  });
  const isChanged =
    isNew || scheduledDate !== reminder.scheduledDate || comment.trim() !== storedComment;
  const isStorable = isChanged && scheduledDate > today;

  return {
    scheduledDate,
    setScheduledDate,
    comment,
    setComment,
    earliestDate: addDays(parseISO(today), 1),
    isStorable,
    isPending: saveMutation.isPending || removeMutation.isPending,
    save: () => {
      if (isStorable) saveMutation.mutate();
    },
    discard: isNew ? onDiscardNew : () => removeMutation.mutate(),
  };
};
